module.exports = __webpack_public_path__ + "static/media/xb4.87896ecd.jpg";